import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useSite } from '../content/SiteContext';
import LanguageSwitcher from './LanguageSwitcher';

const NAV_ITEMS = ['servicios', 'proyectos', 'premios', 'advergames', 'contacto'];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { content, t } = useSite();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <motion.header
      className="absolute top-0 left-0 right-0 z-50 p-4 md:p-6"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <nav className="container mx-auto flex justify-between items-center">
        <motion.div
          className="flex items-center"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <a href="#inicio">
            <img src="/logo.png" alt="Logo 8BITS" className="h-16 md:h-20 w-auto" style={{maxHeight:80}} />
          </a>
        </motion.div>

        <div className="flex items-center gap-4 lg:gap-8">
        {/* Menú desktop */}
        <ul className="hidden md:flex space-x-6 lg:space-x-8 text-base lg:text-lg font-medium">
          {NAV_ITEMS.map((item, index) => (
            <motion.li
              key={item}
              whileHover={{ scale: 1.1, color: '#8B5CF6' }}
              whileTap={{ scale: 0.9 }}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 + 0.5 }}
            >
              <a href={`#${item}`} className="text-white hover:text-purple-400 transition-colors duration-300">
                {t(content.nav[item])}
              </a>
            </motion.li>
          ))}
        </ul>

        <LanguageSwitcher />

        {/* Botón hamburguesa móvil */}
        <motion.button
          className="md:hidden text-white p-2"
          onClick={toggleMenu}
          whileTap={{ scale: 0.95 }}
        >
          <div className="w-6 h-6 flex flex-col justify-center items-center">
            <motion.span
              className="w-6 h-0.5 bg-white mb-1"
              animate={isMenuOpen ? { rotate: 45, y: 6 } : { rotate: 0, y: 0 }}
              transition={{ duration: 0.3 }}
            />
            <motion.span
              className="w-6 h-0.5 bg-white mb-1"
              animate={isMenuOpen ? { opacity: 0 } : { opacity: 1 }}
              transition={{ duration: 0.3 }}
            />
            <motion.span
              className="w-6 h-0.5 bg-white"
              animate={isMenuOpen ? { rotate: -45, y: -6 } : { rotate: 0, y: 0 }}
              transition={{ duration: 0.3 }}
            />
          </div>
        </motion.button>
        </div>
      </nav>

      {/* Menú móvil */}
      <motion.div
        className="md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-lg border-b border-white/10"
        initial={{ opacity: 0, height: 0 }}
        animate={{ 
          opacity: isMenuOpen ? 1 : 0,
          height: isMenuOpen ? 'auto' : 0
        }}
        transition={{ duration: 0.3 }}
      >
        <ul className="container mx-auto px-4 py-4 space-y-4">
          {NAV_ITEMS.map((item, index) => (
            <motion.li
              key={item}
              initial={{ opacity: 0, x: -20 }}
              animate={{ 
                opacity: isMenuOpen ? 1 : 0,
                x: isMenuOpen ? 0 : -20
              }}
              transition={{ delay: index * 0.1 }}
            >
              <a 
                href={`#${item}`} 
                className="block text-white hover:text-purple-400 transition-colors duration-300 py-2 text-lg"
                onClick={() => setIsMenuOpen(false)}
              >
                {t(content.nav[item])}
              </a>
            </motion.li>
          ))}
        </ul>
      </motion.div>
    </motion.header>
  );
};

export default Header; 